<template>
</template>

<script>
  export default {

    mounted(){

      this.$router.push('/');

    }


  }

</script>



// WEBPACK FOOTER //
// src/components/Shared/NotFound/NotFound.vue